import React, {useState} from 'react';
import {useQuery} from "react-query";
import { useNavigate} from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import ExclusiveModal from '../common/exclusive-modal';
import { SELECTED_LANG } from '../../services/common/Constants';
import { getItemOfSessionStorage } from '../../services/common/utils';
const OffersForYou=({pmsitem})=> {
  const [show, setShow] = useState(false);
  const [displaytext, setDisplayText] = useState();
  const lang = getItemOfSessionStorage(SELECTED_LANG);
  const navigate = useNavigate()
    const {
        data: {data} ={},
        isLoading,
        isFetching
    }=useQuery(["", pmsitem.method, JSON.parse(pmsitem.sourceid),{}, false], 
    {retry: false,
    retryOnMount: false,
    cacheTime: 0,
    staleTime: 0
    })

    const handleClick = (item)=>{
      const redirectUrl  = item?.metadata?.filter(obj => obj?.meta_key === "redirecturl_web")[0]?.meta_value_arabic
      
      const flag = item?.metadata?.filter(obj => obj?.meta_key === "web_notallowed")[0]?.meta_value_arabic;
      if(flag === "true"){
        setDisplayText(item?.displaytext)
        setShow(true);
      }else{
      navigate(`/${redirectUrl}`)
      }
    }

    if(isLoading || isFetching){
      return(
        <div class="dls-sprint13-offers dls-sprint13-comp">
    <div class="flex_grp_between mb-3">
        <h3 class="section_title_light mb-0 shimmerBG shimmer-text-lg w-50"></h3>
    </div>
    <Swiper className="dls13_offers_swiper1"
            spaceBetween={12}
            pagination={false}
            slidesPerView={1.8}
            grid={{ rows: 1, fill: "row" }}>
        <SwiperSlide className="swiper-slide offer_card_style_2 shimmerBG shimmer-offer-img">
        </SwiperSlide>
        <SwiperSlide className="swiper-slide offer_card_style_2 shimmerBG shimmer-offer-img">
        </SwiperSlide>
        <SwiperSlide className="swiper-slide offer_card_style_2 shimmerBG shimmer-offer-img">
        </SwiperSlide>
        <SwiperSlide className="swiper-slide offer_card_style_2 shimmerBG shimmer-offer-img">
        </SwiperSlide>

    </Swiper>
</div>
      );
    }

      return (
    <div class="dls-sprint13-offers dls-sprint13-comp">
      <div class="flex_grp_between mb-3">
        <h3 class="section_title_light mb-0">{pmsitem?.elementmeta?.title}</h3>
      </div>
      <div class="swiper-container dls13_offers_swiper1">
      <Swiper 
      // className="dashboard_swiper" 
      spaceBetween={12} 
      slidesPerView={1.38}
      >
        {data?.response?.dynamictypes?.[0]?.cards?.map((item, index) => {

          let titleColor = '';
          let descColor = '';
          let btnViewColor = '';
          let btnTextColor = '';
          let enableZoom = '';
          let zoomIcon = '';
          let buttonText = '';

          item?.metadata.map((itemvalue, i) => {
            if (itemvalue?.meta_key == 'titlecolor') {
              titleColor = lang === 'ar'
                ? itemvalue?.meta_value_arabic
                : itemvalue?.meta_value_english;
            }
            if (itemvalue?.meta_key == 'desccolor') {
              descColor = lang === 'ar'
                ? itemvalue?.meta_value_arabic
                : itemvalue?.meta_value_english;
            }
            if (itemvalue?.meta_key == 'buttonbgcolor') {
              btnViewColor = lang === 'ar'
                ? itemvalue?.meta_value_arabic
                : itemvalue?.meta_value_english;
            }
            if (itemvalue?.meta_key == 'buttontextcolor') {
              btnTextColor = lang === 'ar'
                ? itemvalue?.meta_value_arabic
                : itemvalue?.meta_value_english;
            }
            if (itemvalue?.meta_key == 'enable_zoom') {
              enableZoom = lang === 'ar'
                ? itemvalue?.meta_value_arabic
                : itemvalue?.meta_value_english;
            }
            if (itemvalue?.meta_key == 'zoom_icon') {
              zoomIcon = lang === 'ar'
                ? itemvalue?.meta_value_arabic
                : itemvalue?.meta_value_english;
            }
            if (itemvalue?.meta_key == 'enable_buttontext') {
              buttonText = lang === 'ar'
                ? itemvalue?.meta_value_arabic
                : itemvalue?.meta_value_english;
            }
          });

          // console.log(`item==>${index}`, enableZoom);

          return (
            <SwiperSlide key={index} 
            // className={(
            //   (lang=== 'en' && item?.metadata?.find(obj => obj?.meta_key === "enable_zoom" )?.meta_value_english === 'F') ||
            //   (lang=== 'ar' && item?.metadata?.find(obj => obj?.meta_key === "enable_zoom" )?.meta_value_arabic === 'F' )) ? 'transition-inactive' : 'transition-active' }
            className={`${enableZoom == 'T' ? 'transition-active' : 'transition-inactive'}`}
            >
              {/* <button>{item?.displaytext}</button>
              <button>{item?.buttontext}</button> */}
              <div className='sprint16-swiper-overly-content' onClick={()=>handleClick(item)}>
                {
                  enableZoom == 'T' && (
              <div className='sprint16-swiper-content'>
              <div className='sprint16-swiper-row1'>
              <h4 style={{ color: titleColor }}>{item?.displaytext}</h4>
              <p style={{ color: descColor }}>{item?.description}</p>
              </div>
              <div className='w-50'>
                {
                  buttonText == 'T' && (
                    <button class="custom_btn custom_btn_primary btn_block sp16_custom_btn " 
                    // style={{background:item?.metadata?.filter(obj => obj?.meta_key === "buttonbgcolor")[0]?.meta_value_arabic, color:item?.metadata?.filter(obj => obj?.meta_key === "buttontextcolor")[0]?.meta_value_arabic}}
                    style={{backgroundColor: btnViewColor, color: btnTextColor}}
                  > {item?.buttontext} </button>
                  )
                }
              </div>
              </div>
                  )
                }
              <img src={enableZoom == 'T' ? zoomIcon : item?.imageurl}></img>
              </div>
              {/* <img onClick={() => item?.metadata?.map(item => item?.meta_key === "redirecturl_web" ?  navigate(`/${item?.meta_value_english}`) : "" )} src={process.env.PUBLIC_URL + "/assets/images/offersForYou2.png"}></img> */}
            </SwiperSlide>
          )
        })}
      </Swiper>
    </div>
    
      <ExclusiveModal
        show={show}
        toggleModal={()=> setShow(!show)}
        deeplinktext={displaytext}
      />
    
    </div>
  )
}

export default OffersForYou;
